import { apiServices } from '../services/api.services';
import store from '../store';
import { toast } from 'react-toastify';
import i18n from '../../i18n';
import errorsHandled from '../../variables/errorsHandled';

export const switchBtn = (id, value) => {
  return async (Dispatch) => {
      var args = {
        id: id,
        state: value
      };
      await apiServices.post("/setSwitch", args).then((res) => {
        Dispatch({type: 'SWITCH_BTN', id, value});
      }).catch(err => {
        return err;
      });   
  };
};

export const switchDelete = (id) => {
  return async (Dispatch) => {
    var args = {id};
    await apiServices.post("/deleteDevice", args).then((res) => {
      if (res && res.data && res.data.success) {
        Dispatch({type: 'SWITCH_DELETE', id});
        toast.success(i18n.t('devices:deviceUnlisted'));
      }
    }).catch(err => {
      return err;
    });   
};


};

export const switchEnterEditMode = (id) => {
  return async (Dispatch) => {
    Dispatch({type: 'SWITCH_ENTER_EDIT', id});
  };
}

export const switchCancelEditMode = (id) => {
  return async (Dispatch) => {
    Dispatch({type: 'SWITCH_CANCEL_EDIT', id});
  }
}

const deviceName = /^[\p{L} \-\d]{0,24}$/u;
const command = /^[\p{L} \-\d]{0,12}$/u;
const features = [
  {
    key: 'autoOn',
    plan: 2
  },
  {
    key: 'isSAM',
    plan: 3
  },
  {
    key: 'isAutoNight',
    plan: 3
  },
  {
    key: 'isAutoDay',
    plan: 3
  },
  {
    key: 'autoOff',
    plan: 3
  },
  {
    key: 'parent',
    plan: 2
  },
  {
    key: 'isReverted',
    plan: 3
  },
  {
    key: 'isCyclic',
    plan: 3
  }
];

export const switchPreEdit = (id, part, value) => {
  var userPlan = store.getState().infos.vip.plan;
  var devices = store.getState().devices.switches;
  var found = false;
  const checkObject = part.split('.');
  if (checkObject.length > 1) found = features.findIndex(f => f.key === checkObject[0]);
  else found = features.findIndex(f => f.key === part);

  if (found > -1) {
    if (userPlan < features[found].plan) {
      // send notif
      return;
    }
  }
  if (part === "autoOn" || part === "autoOff") {
    if (isNaN(value)) return;
    value = value < 0 ? 0 : value > 9999 ? 9999 : value;
  } else if (part === "command") {
    if (!command.test(value)) return
    var checkForParent = devices.filter(s => s.id !== id && s.command === value && !s.parent);
    if (checkForParent.length) switchPreEdit(id, "parent", checkForParent[0].id);
  } else if(part === "name") {
    if (!deviceName.test(value)) return;
  }
  store.dispatch({type: 'SWITCH_PRE_EDIT', id, part, value});
  if (["isSAM", "isAutoNight", "isAutoDay", "isReverted", "isCyclic.enabled", "parent"].includes(part)) {
    setTimeout(function() {
      devices = store.getState().devices.switches;
      const index = devices.findIndex((d) => d.id === id);
      switchConfirmEdit(id, devices[index].edit.command, devices[index].edit.autoOn, devices[index].edit.name, devices[index].edit.isSAM, devices[index].edit.autoOff, devices[index].edit.isAutoNight, devices[index].edit.parent, devices[index].edit.isAutoDay, devices[index].edit.isReverted, devices[index].edit.isCyclic);
    }, 200);
  }
}
export const switchConfirmEdit = (id, command, autoOn, name, isSAM, autoOff, isAutoNight, parent, isAutoDay, isReverted, isCyclic) => {
  var devices = store.getState().devices.switches;
  const index = devices.findIndex((d) => d.id === id);
  var edited = true;
  if (index === -1) return;
  if (devices[index].name === name && devices[index].command === command && devices[index].autoOn === autoOn && devices[index].isSAM === isSAM && devices[index].autoOff === autoOff && devices[index].isAutoNight === isAutoNight && devices[index].parent === parent && isAutoDay === devices[index].isAutoDay && isReverted === devices[index].isReverted && isCyclic === devices[index].isCyclic) 
    edited = false;
  if (!edited) return;
  isCyclic.on = isCyclic.on < 10 ? 10 : isCyclic.on > 7200 ? 7200 : isCyclic.on;
  isCyclic.off = isCyclic.off < 10 ? 10 : isCyclic.off > 7200 ? 7200 : isCyclic.off;
  const args = {
    id,
    command,
    autoOn: autoOff !== devices[index].autoOff ? "0" : autoOn ? autoOn.toString() : "0",
    name,
    isSAM: isSAM.toString(),
    isAutoNight: isAutoNight.toString(),
    autoOff: autoOn !== devices[index].autoOn ? "0" : autoOff ? autoOff.toString() : "0",
    parent,
    isAutoDay: isAutoDay.toString(),
    isReverted: isReverted.toString(),
    isCyclic : {
      ...isCyclic,
      enabled: isCyclic.enabled.toString()
    }
  };
  apiServices.post("/updateDevice", args).then((res) => {
    if (res && res.data) {
      if (res.data.success) store.dispatch({type: 'SWITCH_EDIT_UPDATE', id, command, autoOn: autoOff !== devices[index].autoOff ? null : parseInt(autoOn, 10), name, isSAM, autoOff: autoOn !== devices[index].autoOn ? null : parseInt(autoOff, 10), isAutoNight, parent : parent !== "0" ? parent : null, isAutoDay, isReverted, isCyclic});
      if (res.data.error && res.data.code) {
        if (errorsHandled.includes(res.data.code)) {
          apiServices.refreshServersAndDevices();
          if (res.data.code === "9002" || res.data.code === "9003" || res.data.code === "9004") {
            toast.info(i18n.t(`devices:error:wrongDevice`));
          }
          else if (res.data.code === "OTHER_CYCLE") toast.error(i18n.t(`devices:error.otherCycle`));
          else toast.error(i18n.t(`devices:error:${res.data.code}`));
        }
      }
    } else return store.dispatch({type: 'SWITCH_EDIT_RESET', id});
  }).catch(err => {
    return store.dispatch({type: 'SWITCH_EDIT_RESET', id});
  });
}